import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {AfterViewInit, Component, OnInit} from '@angular/core';
import {RouterLink} from '@angular/router';
import {BlogPostListItem} from '../../../interfaces/blog';
import {AosService} from '../../../services/aos.service';
import {BlogService} from '../../../services/blog.service';
import {SeoService} from '../../../services/seo.service';
import {env} from '../../../../environments/environment';

@Component({
    selector: 'app-blog-index-page',
    standalone: true,
    imports: [
        DatePipe,
        NgForOf,
        NgIf,
        RouterLink,
    ],
    templateUrl: './blog-index-page.component.html',
    styleUrl: './blog-index-page.component.scss',
})
export class BlogIndexPageComponent implements OnInit, AfterViewInit {
    posts: BlogPostListItem[] = [];
    isLoading = true;
    hasLoadError = false;
    readonly skeletonCards = Array.from({length: 3});
    protected readonly env = env;

    constructor(
        private aosService: AosService,
        private blogService: BlogService,
        private seoService: SeoService,
    ) {
    }

    ngOnInit(): void {
        this.seoService.applyPage({
            title: 'Блог MotorDesk - статьи про учёт расходов, ТО, пробег и владение автомобилем',
            h1: 'Блог MotorDesk',
            description: 'Практические материалы для автовладельцев: учёт расходов на автомобиль, сервисная история, план ТО, пробег, заправки и стоимость владения.',
            og_title: 'Блог MotorDesk для автовладельцев',
            og_description: 'Разбираем, как спокойнее вести автомобиль: расходы, обслуживание, пробег, заправки и план будущих работ.',
        }, {
            path: '/blog',
            breadcrumb: [
                {name: 'Главная', path: '/'},
                {name: 'Блог', path: '/blog'},
            ],
        });

        this.blogService.getPosts().subscribe({
            next: (posts) => {
                this.posts = posts;
                this.isLoading = false;
                void this.aosService.refresh();
            },
            error: () => {
                this.hasLoadError = true;
                this.isLoading = false;
                void this.aosService.refresh();
            },
        });
    }

    ngAfterViewInit(): void {
        void this.aosService.refresh();
    }

    getAosDelay(index: number, step = 90, max = 270): string {
        return `${Math.min(index * step, max)}`;
    }
}
